module.exports = "/_next/static/images/Document@2x-386942e546c20e523e6bcfec7f58d073.png";